export * from './simple-layout.component';



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/containers/simple-layout/index.ts